module.exports = __webpack_public_path__ + "img/bg-gamePlan.0b8c9676.png";